module.exports = function getResource(label, vars) {
    const resources = {
        editLinkText: 'Edit',
        giftOptionsLinkText: 'Add gift options',
        savedGiftMessage: `Gift Message: ${vars[0]}`,
        savedGiftWrap: `Gift Wrap: ${vars[0]}`,
        subTitle: 'FREE - Standard Shipping',
        title: 'Standard'
    };

    return resources[label];
};
